import React, { useState, useEffect } from "react";
import ProfileChangesPage from "../../../../entities/DashboardPage/HRModule/ProfileChanges";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";

const ProfileChanges = () => {
  const [data, setData] = useState([]);
  const { showAlert } = useAlert();

  useEffect(() => {
    fetchPendingUpdates();
  }, []);

  const fetchPendingUpdates = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPendingUpdates();
      if (result?.success) {
        setData(result?.data || []);
        window.dispatchEvent(new CustomEvent("profileChangesUpdated"));
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleStatusChange = async (id, action, fields, commentsMap, overallComment) => {
    LoaderHelper.loaderStatus(true);
    try {
      const payload = {
        comments: commentsMap || {},
        overallComment: overallComment || ""
      };
      if (action === "approve") {
        payload.approvedFields = fields;
      } else {
        payload.rejectedFields = fields;
      }

      const res = await AuthService.handlePendingUpdateStatus(id, action, payload);
      if (res?.success) {
        showAlert(`Request ${action}d successfully`, "success");
        fetchPendingUpdates();
      } else {
        showAlert(res?.message || `Failed to ${action} request`, "error");
      }
    } catch (e) {
      showAlert(e?.message, "error");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  return <ProfileChangesPage data={data} onStatusChange={handleStatusChange} />;
};

export default ProfileChanges;
